// Partner banner showing project sponsor (Diocese) + collaborator (ALFRED Initiatives)
const DIOCESE_LOGO =
  "https://customer-assets-agu9un31.emergentagent.net/job_carbon-analytics-3/artifacts/9nx4lcam_PDCJC.jpg";
const ALFRED_LOGO =
  "https://customer-assets-agu9un31.emergentagent.net/job_carbon-analytics-3/artifacts/ppv4mko9_ALFREDInitiatives.jpg";

export function PartnerBanner({ variant = "stacked", className = "" }) {
  // variant: "stacked" (two rows, big) | "compact" (inline, one row, small)

  if (variant === "compact") {
    return (
      <div
        data-testid="partner-banner"
        className={`flex flex-wrap items-center gap-x-6 gap-y-3 ${className}`}
      >
        <div className="flex items-center gap-2">
          <img
            src={DIOCESE_LOGO}
            alt="Creation Justice Commission — Diocese of Penang"
            className="h-10 w-10 object-contain"
          />
          <div className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#3d3f3c] leading-tight">
            A Sustainability Project By
            <br />
            <span className="text-[#0F3524]">Creation Justice Commission</span>
            <br />
            Diocese of Penang
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#3d3f3c] leading-tight">
            In Collaboration With
          </div>
          <img
            src={ALFRED_LOGO}
            alt="ALFRED Initiatives — Faith · People · Planet"
            className="h-10 w-auto object-contain"
          />
        </div>
      </div>
    );
  }

  // stacked (default)
  return (
    <div
      data-testid="partner-banner"
      className={`flex flex-col gap-5 ${className}`}
    >
      <div className="flex items-center gap-4">
        <img
          src={DIOCESE_LOGO}
          alt="Creation Justice Commission — Diocese of Penang"
          className="h-20 w-20 object-contain flex-shrink-0"
        />
        <div className="text-xs sm:text-sm font-medium text-[#1A1B1A] leading-snug">
          A Sustainability Project By
          <br />
          <span className="font-display text-base sm:text-lg text-[#0F3524]">
            CREATION JUSTICE COMMISSION
          </span>
          <br />
          <span className="font-display text-base sm:text-lg text-[#0F3524]">
            DIOCESE OF PENANG
          </span>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <img
          src={ALFRED_LOGO}
          alt="ALFRED Initiatives — Faith · People · Planet"
          className="h-20 w-auto object-contain flex-shrink-0"
        />
        <div className="text-xs sm:text-sm font-medium text-[#1A1B1A] leading-snug">
          In Collaboration With
        </div>
      </div>
    </div>
  );
}

export default PartnerBanner;
